import debounce from 'lodash/debounce';

class BrixExpandableList {
  static init(...parameters) {
    return new BrixExpandableList(...parameters);
  }

  constructor(block) {
    this.listItems = block.querySelectorAll('.brix-expandable-list-item');

    this.setupListeners();
  }

  setupListeners() {
    if (this.listItems.length > 0) {
      [...this.listItems].forEach((listItem) => {
        const listItemLabel = listItem.querySelector('.list-item-label');
        const listItemContent = listItem.querySelector('.list-item-content');
        listItemLabel.addEventListener('click', () => this.onClickExpandButton(listItem, listItemContent));
      });
    }

    window.addEventListener('resize', debounce(() => {
      if (this.listItems.length > 0) {
        [...this.listItems].forEach((listItem) => {
          const listItemContent = listItem.querySelector('.list-item-content');
          const innerBlocksWrapper = listItem.querySelector('.inner-blocks');

          if (listItem.classList.contains('-expanded')) {
            listItemContent.style.height = `${innerBlocksWrapper.scrollHeight}px`;
          }
        });
      }
    }, 50));
  }

  onClickExpandButton(listItem, listItemContent) {
    const listItemContentStyle = listItemContent.style;

    if (listItem.classList.contains('-expanded')) {
      listItem.classList.remove('-expanded');
      listItemContentStyle.height = '0px';
      listItem.setAttribute('aria-expanded', false);
    } else {
      listItem.classList.add('-expanded');
      listItemContentStyle.height = `${listItemContent.scrollHeight}px`;
      listItem.setAttribute('aria-expanded', true);
    }
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-expandable-list', BrixExpandableList.init);
}
